import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import API from '../services/api';

export default function Superadmin() {
  const { logout } = useAuth();
  const [empresas, setEmpresas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [msg, setMsg] = useState('');
  const [editando, setEditando] = useState(null);
  const [empresaDetalle, setEmpresaDetalle] = useState(null);
  const [busqueda, setBusqueda] = useState('');
  const [usuarios, setUsuarios] = useState([]);
  const [loadingUsuarios, setLoadingUsuarios] = useState(false);
  const [logEmpresa, setLogEmpresa] = useState([]);
  const [loadingLog, setLoadingLog] = useState(false);

  const cargar = async () => {
    setLoading(true);
    try {
      const res = await API.get('/api/superadmin/empresas');
      setEmpresas(res.data);
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  useEffect(() => { cargar(); }, []);

  const activar = async (id, nombre) => {
    if (!window.confirm('¿Activar cuenta de ' + nombre + '?')) return;
    await API.post('/api/superadmin/empresas/' + id + '/activar');
    setMsg('✓ ' + nombre + ' activada');
    cargar();
  };

  const activarPeriodo = async (id, nombre) => {
    const opciones = ['1mes', '1anio', 'perpetual'];
    const etiquetas = ['1 mes', '1 año', 'Permanente'];
    const idx = window.prompt('Periodo para ' + nombre + ':\n0 = 1 mes\n1 = 1 año\n2 = Permanente\nIntroduce 0, 1 o 2:', '0');
    if (idx === null) return;
    const periodo = opciones[parseInt(idx)];
    if (!periodo) { alert('Opcion no valida'); return; }
    await API.post('/api/superadmin/empresas/' + id + '/activar-periodo?periodo=' + periodo);
    setMsg('✓ ' + nombre + ' activada — ' + etiquetas[parseInt(idx)]);
    if (empresaDetalle?.id === id) {
      const logRes = await API.get('/api/superadmin/empresas/' + id + '/log');
      setLogEmpresa(logRes.data);
    }
    cargar();
  };

  const pausar = async (id, nombre, pausado) => {
    const accion = pausado ? 'reactivar' : 'pausar';
    if (!window.confirm('¿' + accion.charAt(0).toUpperCase() + accion.slice(1) + ' la cuenta de ' + nombre + '?')) return;
    await API.post('/api/superadmin/empresas/' + id + '/pausar?pausar=' + !pausado);
    setMsg('✓ Cuenta de ' + nombre + ' ' + (pausado ? 'reactivada' : 'pausada'));
    if (empresaDetalle?.id === id) setEmpresaDetalle({...empresaDetalle, pausada: !pausado});
    cargar();
  };

  const extender = async (id, nombre) => {
    const dias = window.prompt('¿Cuántos días extender el trial de ' + nombre + '?', '7');
    if (!dias) return;
    await API.post('/api/superadmin/empresas/' + id + '/extender-trial?dias=' + dias);
    setMsg('✓ Trial de ' + nombre + ' extendido ' + dias + ' días');
    cargar();
  };

  const guardarEdicion = async (id) => {
    const e = editando;
    await API.post('/api/superadmin/empresas/' + id + '/max-empleados?max_empleados=' + e.max_empleados);
    await API.post('/api/superadmin/empresas/' + id + '/plan?plan=' + e.plan);
    if (e.modo_pago) await API.post('/api/superadmin/empresas/' + id + '/modo-pago?modo_pago=' + e.modo_pago);
    setMsg('✓ Cambios guardados');
    setEditando(null);
    // Recargar log si estamos en el detalle
    if (empresaDetalle?.id === id) {
      const logRes = await API.get('/api/superadmin/empresas/' + id + '/log');
      setLogEmpresa(logRes.data);
      setEmpresaDetalle({...empresaDetalle, plan: e.plan, modo_pago: e.modo_pago, max_empleados: e.max_empleados});
    }
    cargar();
  };

  const verUsuarios = async (empresa) => {
    setEmpresaDetalle(empresa);
    setLoadingUsuarios(true);
    setLoadingLog(true);
    try {
      const [usuRes, logRes] = await Promise.all([
        API.get('/api/superadmin/empresas/' + empresa.id + '/usuarios'),
        API.get('/api/superadmin/empresas/' + empresa.id + '/log'),
      ]);
      setUsuarios(usuRes.data);
      setLogEmpresa(logRes.data);
    } catch(e) { console.error(e); }
    setLoadingUsuarios(false);
    setLoadingLog(false);
  };

  const PRECIOS = { control: 14, gestion: 29, empresa: 69 };
  const PRECIOS_ANUAL = { control: 140, gestion: 290, empresa: 690 };

  const precioLabel = (plan, anual) => {
    const p = anual ? PRECIOS_ANUAL[plan] : PRECIOS[plan];
    return p ? '(' + p + (anual ? '€/año' : '€/mes') + ')' : '';
  };

  const estadoColor = (estado) => {
    if (estado === 'pagado') return '#34d399';
    if (estado && estado.startsWith('trial')) return '#e8a838';
    return '#f87171';
  };

  const inputStyle = {
    background:'#16181d', border:'1px solid #4f8ef7', color:'#eef0f6',
    padding:'4px 8px', fontSize:'13px', borderRadius:'2px', width:'100%'
  };

  return (
    <div style={{minHeight:'100vh',background:'#16181d',padding:'32px 24px'}}>
      <div style={{maxWidth:'1100px',margin:'0 auto'}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'32px'}}>
          <div>
            <div style={{fontFamily:'monospace',fontSize:'11px',color:'#7a8099',letterSpacing:'2px',marginBottom:'4px'}}>// PANEL</div>
            <h1 style={{color:'#eef0f6',fontSize:'28px',fontWeight:'700',margin:0}}>Superadmin</h1>
          </div>
          <button onClick={logout} style={{background:'transparent',border:'1px solid #2e3140',color:'#7a8099',padding:'8px 16px',cursor:'pointer',fontSize:'13px',borderRadius:'4px'}}>Cerrar sesión</button>
        </div>

        {msg && (
          <div style={{background:'rgba(52,211,153,0.08)',border:'1px solid rgba(52,211,153,0.3)',color:'#34d399',padding:'12px 16px',marginBottom:'24px',borderRadius:'4px',fontSize:'14px'}}>{msg}</div>
        )}

        {(() => {
          const todas = empresas.filter(e => e.nombre !== '_superadmin_');
          const activas = todas.filter(e => e.plan_pagado);
          const enTrial = todas.filter(e => !e.plan_pagado && e.estado?.startsWith('trial')).length;
          const porExpirar = activas.filter(e => e.fecha_fin_pago && Math.ceil((new Date(e.fecha_fin_pago) - new Date()) / (1000*60*60*24)) <= 7).length;
          const mrr = activas.reduce((acc, e) => {
            if (e.modo_pago === 'anual') return acc + Math.round((PRECIOS_ANUAL[e.plan]||0)/12);
            return acc + (PRECIOS[e.plan]||0);
          }, 0);
          const facAnual = activas.reduce((acc, e) => {
            if (e.modo_pago === 'anual') return acc + (PRECIOS_ANUAL[e.plan]||0);
            return acc + (PRECIOS[e.plan]||0)*12;
          }, 0);
          return (
            <div style={{display:'grid',gridTemplateColumns:'repeat(5,1fr)',gap:'8px',marginBottom:'24px'}}>
              {[
                {label:'TOTAL EMPRESAS', value: todas.length, color:'#eef0f6'},
                {label:'CLIENTES ACTIVOS', value: activas.length, color:'#34d399', extra: porExpirar>0 ? '⚠️ '+porExpirar+' vencen pronto' : null},
                {label:'EN TRIAL', value: enTrial, color:'#e8a838'},
                {label:'MRR (sin IVA)', value: mrr+'€', color:'#4f8ef7'},
                {label:'FACTURACIÓN ANUAL', value: facAnual+'€', color:'#4f8ef7'},
              ].map(k => (
                <div key={k.label} style={{background:'#1e2128',border:'1px solid #2e3140',padding:'14px 16px',borderRadius:'4px'}}>
                  <div style={{color:'#7a8099',fontSize:'11px',fontFamily:'monospace',letterSpacing:'1px',marginBottom:'6px'}}>{k.label}</div>
                  <div style={{color:k.color,fontSize:'20px',fontWeight:'700'}}>{k.value}</div>
                  {k.extra && <div style={{color:'#f87171',fontSize:'11px',marginTop:'4px'}}>{k.extra}</div>}
                </div>
              ))}
            </div>
          );
        })()}
        <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:'16px'}}>
          <input
            value={busqueda}
            onChange={e=>setBusqueda(e.target.value)}
            placeholder="Buscar por nombre, email, plan o estado..."
            style={{flex:1,background:'#1e2128',border:'1px solid #2e3140',color:'#eef0f6',padding:'8px 14px',fontSize:'13px',borderRadius:'4px',outline:'none'}}
          />
          {busqueda && <button onClick={()=>setBusqueda('')} style={{background:'transparent',border:'none',color:'#7a8099',cursor:'pointer',fontSize:'13px'}}>✕ Limpiar</button>}
          <span style={{color:'#7a8099',fontSize:'13px',whiteSpace:'nowrap'}}>
            {empresas.filter(e=>e.nombre!=='_superadmin_').length} empresas
          </span>
        </div>

        {loading ? (
          <div style={{color:'#7a8099',textAlign:'center',padding:'48px'}}>Cargando...</div>
        ) : (
          <div style={{display:'flex',flexDirection:'column',gap:'2px'}}>
            {empresas.filter(e => {
            if (e.nombre === '_superadmin_') return false;
            if (!busqueda.trim()) return true;
            const q = busqueda.toLowerCase();
            return (
              e.nombre?.toLowerCase().includes(q) ||
              e.admin_email?.toLowerCase().includes(q) ||
              e.plan?.toLowerCase().includes(q) ||
              e.estado?.toLowerCase().includes(q)
            );
          }).map(e => {
              const esEditando = editando && editando.id === e.id;
              return (
                <div key={e.id} style={{background:'#1e2128',border: esEditando ? '1px solid #4f8ef7' : '1px solid #2e3140',padding:'20px 24px',cursor:'pointer'}} onClick={() => !esEditando && verUsuarios(e)}>
                  <div style={{display:'grid',gridTemplateColumns:'1fr 140px 110px 80px 80px 80px 110px 200px',alignItems:'center',gap:'16px'}}>
                    <div style={{minWidth:0,overflow:'hidden'}}>
                      <div style={{color:'#eef0f6',fontWeight:'600',fontSize:'15px',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{e.nombre}</div>
                      <div style={{color:'#7a8099',fontSize:'12px',marginTop:'2px',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{e.admin_email}</div>
                    </div>

                    <div>
                      <div style={{color:'#7a8099',fontSize:'11px',marginBottom:'4px'}}>PLAN</div>
                      {esEditando ? (
                        <select value={editando.plan} onChange={ev => setEditando({...editando, plan: ev.target.value})} style={inputStyle}>
                          <option value="control">control</option>
                          <option value="gestion">gestion</option>
                          <option value="empresa">empresa</option>
                        </select>
                      ) : (
                        <div style={{color:'#eef0f6',fontSize:'13px',fontFamily:'monospace'}}>{e.plan}</div>
                      )}
                    </div>

                    <div>
                      <div style={{color:'#7a8099',fontSize:'11px',marginBottom:'4px'}}>MÁX. EMPLEADOS</div>
                      {esEditando ? (
                        <input type="number" value={editando.max_empleados} onChange={ev => setEditando({...editando, max_empleados: parseInt(ev.target.value)})} style={inputStyle} />
                      ) : (
                        <div style={{color:'#eef0f6',fontSize:'13px'}}>{e.max_empleados || 20}</div>
                      )}
                    </div>

                    <div>
                      <div style={{color:'#7a8099',fontSize:'11px',marginBottom:'4px'}}>ACTIVOS</div>
                      <div style={{color:'#eef0f6',fontSize:'13px'}}>{e.num_empleados}</div>
                    </div>

                    <div>
                      <div style={{color:'#7a8099',fontSize:'11px',marginBottom:'4px'}}>ALTA</div>
                      <div style={{color:'#eef0f6',fontSize:'12px'}}>{e.creada_en ? new Date(e.creada_en).toLocaleDateString('es-ES') : '—'}</div>
                    </div>
                    <div>
                      <div style={{color:'#7a8099',fontSize:'11px',marginBottom:'4px'}}>VENCE</div>
                      {e.fecha_fin_pago ? (() => {
                        const dias = Math.ceil((new Date(e.fecha_fin_pago) - new Date()) / (1000*60*60*24));
                        return <div style={{color:dias<=7?'#f87171':'#eef0f6',fontSize:'12px',fontWeight:dias<=7?'600':'400'}}>{dias>0?dias+'d':'Expirado'}</div>;
                      })() : <div style={{color:'#7a8099',fontSize:'12px'}}>—</div>}
                    </div>
                    <div>
                      <div style={{color:'#7a8099',fontSize:'11px',marginBottom:'4px'}}>IMPORTE</div>
                      <div style={{color:'#34d399',fontSize:'13px',fontWeight:'600'}}>
                        {e.modo_pago === 'anual' ? (PRECIOS_ANUAL[e.plan] || '—') + '€/año' : (PRECIOS[e.plan] || '—') + '€/mes'}
                      </div>
                      <div style={{color:'#7a8099',fontSize:'10px'}}>sin IVA</div>
                    </div>

                    <div style={{display:'flex',flexDirection:'column',gap:'6px',alignItems:'flex-end'}}>
                      <div style={{background:estadoColor(e.estado)+'18',color:estadoColor(e.estado),padding:'3px 10px',fontSize:'11px',fontFamily:'monospace',borderRadius:'2px',whiteSpace:'nowrap'}}>{e.estado}</div>
                      <div style={{display:'flex',gap:'6px',flexWrap:'wrap',justifyContent:'flex-end'}}>
                        {esEditando ? (
                          <>
                            <button onClick={() => guardarEdicion(e.id)} style={{background:'#34d399',color:'#000',border:'none',padding:'5px 10px',fontSize:'11px',cursor:'pointer',borderRadius:'2px',fontWeight:'700'}}>Guardar</button>
                            <button onClick={() => setEditando(null)} style={{background:'transparent',color:'#7a8099',border:'1px solid #2e3140',padding:'5px 10px',fontSize:'11px',cursor:'pointer',borderRadius:'2px'}}>Cancelar</button>
                          </>
                        ) : (
                          <>
                            <button onClick={() => setEditando({id: e.id, plan: e.plan, max_empleados: e.max_empleados || 20, modo_pago: e.modo_pago || 'mensual'})} style={{background:'transparent',color:'#4f8ef7',border:'1px solid #4f8ef7',padding:'5px 10px',fontSize:'11px',cursor:'pointer',borderRadius:'2px'}}>Editar</button>
                            {!e.plan_pagado && <button onClick={() => activar(e.id, e.nombre)} style={{background:'#4f8ef7',color:'#fff',border:'none',padding:'5px 10px',fontSize:'11px',cursor:'pointer',borderRadius:'2px'}}>Activar</button>}
                            <button onClick={() => extender(e.id, e.nombre)} style={{background:'transparent',color:'#7a8099',border:'1px solid #2e3140',padding:'5px 10px',fontSize:'11px',cursor:'pointer',borderRadius:'2px'}}>+Trial</button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* Modal detalle empresa - pantalla completa */}
      {empresaDetalle && (
        <div style={{position:'fixed',inset:0,background:'#16181d',zIndex:100,overflowY:'auto'}}>
          <div style={{maxWidth:'900px',margin:'0 auto',padding:'32px 24px'}}>

            {/* Header */}
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:'32px'}}>
              <div>
                <button onClick={() => setEmpresaDetalle(null)} style={{background:'transparent',border:'none',color:'#7a8099',cursor:'pointer',fontSize:'13px',padding:'0',marginBottom:'12px',display:'flex',alignItems:'center',gap:'6px'}}>← Volver al panel</button>
                <div style={{fontFamily:'monospace',fontSize:'11px',color:'#7a8099',letterSpacing:'2px',marginBottom:'6px'}}>// DETALLE EMPRESA</div>
                <h1 style={{color:'#eef0f6',fontSize:'32px',fontWeight:'700',margin:'0 0 4px 0'}}>{empresaDetalle.nombre}</h1>
                <div style={{color:'#7a8099',fontSize:'14px'}}>{empresaDetalle.admin_email}</div>
              </div>
              <div style={{background:estadoColor(empresaDetalle.estado)+'18',color:estadoColor(empresaDetalle.estado),padding:'6px 14px',fontSize:'12px',fontFamily:'monospace',borderRadius:'2px'}}>{empresaDetalle.estado}</div>
            </div>

            {/* Info pago */}
            {empresaDetalle.plan_pagado && empresaDetalle.fecha_activacion && (() => {
              const PRECIOS = { control: 14, gestion: 29, empresa: 69 };
              const PRECIOS_ANUAL = { control: 140, gestion: 290, empresa: 690 };
              const esAnual = empresaDetalle.modo_pago === 'anual';
              const precio = esAnual ? PRECIOS_ANUAL[empresaDetalle.plan] : PRECIOS[empresaDetalle.plan];
              const fechaInicio = new Date(empresaDetalle.fecha_activacion);
              const proximoPago = new Date(fechaInicio);
              if (esAnual) proximoPago.setFullYear(proximoPago.getFullYear() + 1);
              else proximoPago.setMonth(proximoPago.getMonth() + 1);
              // Avanzar hasta que sea futura
              const hoy = new Date();
              while (proximoPago < hoy) {
                if (esAnual) proximoPago.setFullYear(proximoPago.getFullYear() + 1);
                else proximoPago.setMonth(proximoPago.getMonth() + 1);
              }
              const diasRestantes = Math.ceil((proximoPago - hoy) / (1000 * 60 * 60 * 24));
              return (
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:'8px',marginBottom:'16px'}}>
                  <div style={{background:'rgba(52,211,153,0.08)',border:'1px solid rgba(52,211,153,0.2)',padding:'12px 16px',borderRadius:'4px'}}>
                    <div style={{color:'#7a8099',fontSize:'11px',fontFamily:'monospace',marginBottom:'4px'}}>IMPORTE</div>
                    <div style={{color:'#34d399',fontSize:'18px',fontWeight:'700'}}>{precio}€ <span style={{fontSize:'12px',fontWeight:'400'}}>{esAnual ? '/año' : '/mes'}</span></div>
                    <div style={{color:'#7a8099',fontSize:'11px',marginTop:'2px'}}>sin IVA</div>
                  </div>
                  <div style={{background:'#1e2128',border:'1px solid #2e3140',padding:'12px 16px',borderRadius:'4px'}}>
                    <div style={{color:'#7a8099',fontSize:'11px',fontFamily:'monospace',marginBottom:'4px'}}>ACTIVADO</div>
                    <div style={{color:'#eef0f6',fontSize:'14px',fontWeight:'600'}}>{fechaInicio.toLocaleDateString('es-ES',{day:'numeric',month:'short',year:'numeric'})}</div>
                  </div>
                  <div style={{background:'#1e2128',border:'1px solid #2e3140',padding:'12px 16px',borderRadius:'4px'}}>
                    <div style={{color:'#7a8099',fontSize:'11px',fontFamily:'monospace',marginBottom:'4px'}}>PRÓXIMO PAGO</div>
                    <div style={{color:'#eef0f6',fontSize:'14px',fontWeight:'600'}}>{proximoPago.toLocaleDateString('es-ES',{day:'numeric',month:'short',year:'numeric'})}</div>
                    <div style={{color: diasRestantes <= 7 ? '#f87171' : '#7a8099',fontSize:'11px',marginTop:'2px'}}>en {diasRestantes} días</div>
                  </div>
                </div>
              );
            })()}

            {empresaDetalle.fecha_fin_pago && (() => {
              const dias = Math.ceil((new Date(empresaDetalle.fecha_fin_pago) - new Date()) / (1000*60*60*24));
              return (
                <div style={{background: dias<=7 ? 'rgba(248,113,113,0.08)' : 'rgba(52,211,153,0.08)', border:'1px solid '+(dias<=7?'rgba(248,113,113,0.3)':'rgba(52,211,153,0.3)'), padding:'12px 16px', borderRadius:'4px', marginBottom:'16px', display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                  <div>
                    <div style={{color:dias<=7?'#f87171':'#34d399',fontWeight:'600',fontSize:'14px'}}>Vence el {new Date(empresaDetalle.fecha_fin_pago).toLocaleDateString('es-ES',{day:'numeric',month:'long',year:'numeric'})}</div>
                    <div style={{color:'#7a8099',fontSize:'12px',marginTop:'2px'}}>Quedan {dias} días</div>
                  </div>
                  {dias<=7 && <span style={{fontSize:'20px'}}>⚠️</span>}
                </div>
              );
            })()}
            {/* KPIs editables */}
            <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:'8px',marginBottom:'24px'}}>
              <div style={{background:'#1e2128',border:'1px solid #2e3140',padding:'16px 20px',borderRadius:'4px'}}>
                <div style={{color:'#7a8099',fontSize:'11px',fontFamily:'monospace',letterSpacing:'1px',marginBottom:'8px'}}>PLAN</div>
                <select value={empresaDetalle.plan} onChange={async ev => {
                  await API.post('/api/superadmin/empresas/' + empresaDetalle.id + '/plan?plan=' + ev.target.value);
                  setEmpresaDetalle({...empresaDetalle, plan: ev.target.value});
                  const logRes = await API.get('/api/superadmin/empresas/' + empresaDetalle.id + '/log');
                  setLogEmpresa(logRes.data);
                  cargar();
                }} style={{background:'#252830',border:'1px solid #2e3140',color:'#eef0f6',padding:'4px 8px',fontSize:'13px',borderRadius:'4px',width:'100%',fontFamily:'monospace'}}>
                  <option value="control">control</option>
                  <option value="gestion">gestion</option>
                  <option value="empresa">empresa</option>
                </select>
              </div>
              <div style={{background:'#1e2128',border:'1px solid #2e3140',padding:'16px 20px',borderRadius:'4px'}}>
                <div style={{color:'#7a8099',fontSize:'11px',fontFamily:'monospace',letterSpacing:'1px',marginBottom:'8px'}}>MODO PAGO</div>
                <select value={empresaDetalle.modo_pago || 'mensual'} onChange={async ev => {
                  await API.post('/api/superadmin/empresas/' + empresaDetalle.id + '/modo-pago?modo_pago=' + ev.target.value);
                  setEmpresaDetalle({...empresaDetalle, modo_pago: ev.target.value});
                  const logRes = await API.get('/api/superadmin/empresas/' + empresaDetalle.id + '/log');
                  setLogEmpresa(logRes.data);
                  cargar();
                }} style={{background:'#252830',border:'1px solid #2e3140',color:'#eef0f6',padding:'4px 8px',fontSize:'13px',borderRadius:'4px',width:'100%'}}>
                  <option value="mensual">mensual</option>
                  <option value="anual">anual</option>
                </select>
              </div>
              <div style={{background:'#1e2128',border:'1px solid #2e3140',padding:'16px 20px',borderRadius:'4px'}}>
                <div style={{color:'#7a8099',fontSize:'11px',fontFamily:'monospace',letterSpacing:'1px',marginBottom:'8px'}}>MÁX. EMPLEADOS</div>
                <input type="number" defaultValue={empresaDetalle.max_empleados || 20} onBlur={async ev => {
                  await API.post('/api/superadmin/empresas/' + empresaDetalle.id + '/max-empleados?max_empleados=' + ev.target.value);
                  setEmpresaDetalle({...empresaDetalle, max_empleados: parseInt(ev.target.value)});
                  cargar();
                }} style={{background:'#252830',border:'1px solid #2e3140',color:'#eef0f6',padding:'4px 8px',fontSize:'13px',borderRadius:'4px',width:'100%'}} />
              </div>
              <div style={{background:'#1e2128',border:'1px solid #2e3140',padding:'16px 20px',borderRadius:'4px'}}>
                <div style={{color:'#7a8099',fontSize:'11px',fontFamily:'monospace',letterSpacing:'1px',marginBottom:'8px'}}>EMPLEADOS ACTIVOS</div>
                <div style={{color:'#eef0f6',fontSize:'22px',fontWeight:'700'}}>{empresaDetalle.num_empleados} / {empresaDetalle.max_empleados || 20}</div>
              </div>
            </div>

            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'24px'}}>

              {/* Usuarios */}
              <div>
                <div style={{fontFamily:'monospace',fontSize:'11px',color:'#7a8099',letterSpacing:'2px',marginBottom:'12px'}}>// USUARIOS ({usuarios.length})</div>
                {loadingUsuarios ? (
                  <div style={{color:'#7a8099',padding:'24px',textAlign:'center'}}>Cargando...</div>
                ) : usuarios.length === 0 ? (
                  <div style={{color:'#7a8099',padding:'24px',textAlign:'center',fontSize:'13px',background:'#1e2128',border:'1px solid #2e3140'}}>Sin usuarios</div>
                ) : (
                  <div style={{display:'flex',flexDirection:'column',gap:'2px'}}>
                    {usuarios.map(u => (
                      <div key={u.id} style={{background:'#1e2128',border:'1px solid #2e3140',padding:'14px 16px',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                        <div>
                          <div style={{color:'#eef0f6',fontSize:'14px',fontWeight:'600'}}>{u.nombre}</div>
                          <div style={{color:'#7a8099',fontSize:'12px',marginTop:'2px'}}>{u.email}</div>
                          <div style={{color:'#7a8099',fontSize:'11px',marginTop:'2px'}}>{u.creado_en ? new Date(u.creado_en).toLocaleDateString('es-ES') : ''}</div>
                        </div>
                        <div style={{display:'flex',flexDirection:'column',alignItems:'flex-end',gap:'4px'}}>
                          <div style={{
                            background: u.rol==='admin' ? 'rgba(79,142,247,0.15)' : 'rgba(122,128,153,0.15)',
                            color: u.rol==='admin' ? '#4f8ef7' : '#7a8099',
                            padding:'2px 8px',fontSize:'11px',fontFamily:'monospace',borderRadius:'2px'
                          }}>{u.rol}</div>
                          <div style={{color: u.activo ? '#34d399' : '#f87171',fontSize:'11px'}}>{u.activo ? '● activo' : '○ inactivo'}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Historial de pagos */}
              <div>
                <div style={{fontFamily:'monospace',fontSize:'11px',color:'#7a8099',letterSpacing:'2px',marginBottom:'12px'}}>// HISTORIAL DE PAGOS</div>
                <div style={{background:'#1e2128',border:'1px solid #2e3140',padding:'32px',textAlign:'center',borderRadius:'4px'}}>
                  <div style={{fontSize:'32px',marginBottom:'12px'}}>💳</div>
                  <div style={{color:'#7a8099',fontSize:'13px',lineHeight:'1.6'}}>Historial de pagos disponible<br/>cuando se configure Stripe</div>
                </div>

                {/* Acciones rápidas */}
                <div style={{fontFamily:'monospace',fontSize:'11px',color:'#7a8099',letterSpacing:'2px',margin:'24px 0 12px 0'}}>// ACCIONES</div>
                <div style={{display:'flex',flexDirection:'column',gap:'8px'}}>
                  {!empresaDetalle.plan_pagado && (
                    <button onClick={() => { activar(empresaDetalle.id, empresaDetalle.nombre); setEmpresaDetalle({...empresaDetalle, plan_pagado:true, estado:'pagado'}); }} style={{background:'#4f8ef7',color:'#fff',border:'none',padding:'12px 16px',fontSize:'13px',cursor:'pointer',borderRadius:'4px',fontWeight:'600',textAlign:'left'}}>
                      ✓ Activar cuenta
                    </button>
                  )}
                  <button onClick={() => activarPeriodo(empresaDetalle.id, empresaDetalle.nombre)} style={{background:'transparent',color:'#34d399',border:'1px solid #34d399',padding:'12px 16px',fontSize:'13px',cursor:'pointer',borderRadius:'4px',textAlign:'left'}}>
                    📅 Activar por periodo
                  </button>
                  <button onClick={() => extender(empresaDetalle.id, empresaDetalle.nombre)} style={{background:'transparent',color:'#e8a838',border:'1px solid #e8a838',padding:'12px 16px',fontSize:'13px',cursor:'pointer',borderRadius:'4px',textAlign:'left'}}>
                    + Extender trial
                  </button>
                  <button onClick={() => pausar(empresaDetalle.id, empresaDetalle.nombre, empresaDetalle.pausada)} style={{background:'transparent',color:'#f87171',border:'1px solid #f87171',padding:'12px 16px',fontSize:'13px',cursor:'pointer',borderRadius:'4px',textAlign:'left'}}>
                    {empresaDetalle.pausada ? '▶ Reactivar cuenta' : '⏸ Pausar cuenta'}
                  </button>
                  <button onClick={async () => {
                    if (!window.confirm('¿Eliminar DEFINITIVAMENTE la empresa ' + empresaDetalle.nombre + ' y todos sus datos? Esta acción no se puede deshacer.')) return;
                    if (!window.confirm('SEGUNDA CONFIRMACIÓN: Se eliminarán todos los empleados, fichajes, proyectos y datos. ¿Continuar?')) return;
                    await API.delete('/api/superadmin/empresas/' + empresaDetalle.id);
                    setMsg('✓ Empresa ' + empresaDetalle.nombre + ' eliminada definitivamente');
                    setEmpresaDetalle(null);
                    cargar();
                  }} style={{background:'transparent',color:'#f87171',border:'1px solid #f87171',padding:'12px 16px',fontSize:'13px',cursor:'pointer',borderRadius:'4px',textAlign:'left'}}>
                    🗑 Eliminar definitivamente
                  </button>
                  {empresaDetalle.plan_pagado && (
                    <button onClick={async () => {
                      if (!window.confirm('¿Desactivar cuenta de ' + empresaDetalle.nombre + '? Perderán acceso inmediatamente.')) return;
                      await API.post('/api/superadmin/empresas/' + empresaDetalle.id + '/desactivar');
                      setMsg('✓ Cuenta de ' + empresaDetalle.nombre + ' desactivada');
                      setEmpresaDetalle(null);
                      cargar();
                    }} style={{background:'transparent',color:'#f87171',border:'1px solid #f87171',padding:'12px 16px',fontSize:'13px',cursor:'pointer',borderRadius:'4px',textAlign:'left'}}>
                      ✕ Desactivar cuenta
                    </button>
                  )}
                </div>
              </div>
            </div>

            {/* Historial superadmin */}
            <div style={{fontFamily:'monospace',fontSize:'11px',color:'#7a8099',letterSpacing:'2px',margin:'24px 0 12px 0'}}>// HISTORIAL DE CAMBIOS</div>
            {loadingLog ? (
              <div style={{color:'#7a8099',fontSize:'13px'}}>Cargando...</div>
            ) : logEmpresa.length === 0 ? (
              <div style={{color:'#7a8099',fontSize:'13px',background:'#1e2128',border:'1px solid #2e3140',padding:'16px'}}>Sin actividad registrada</div>
            ) : (
              <div style={{display:'flex',flexDirection:'column',gap:'2px'}}>
                {logEmpresa.map((l,i) => (
                  <div key={i} style={{background:'#1e2128',border:'1px solid #2e3140',padding:'12px 16px',display:'flex',justifyContent:'space-between',alignItems:'flex-start',gap:'16px'}}>
                    <div>
                      <div style={{color:'#eef0f6',fontSize:'13px',fontWeight:'600',fontFamily:'monospace'}}>{l.accion.replace(/_/g,' ').toUpperCase()}</div>
                      {l.detalle && <div style={{color:'#7a8099',fontSize:'12px',marginTop:'2px'}}>{l.detalle}</div>}
                    </div>
                    <div style={{color:'#7a8099',fontSize:'11px',whiteSpace:'nowrap'}}>{l.creado_en ? new Date(l.creado_en).toLocaleDateString('es-ES',{day:'numeric',month:'short',year:'numeric',hour:'2-digit',minute:'2-digit'}) : ''}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
